import { useMutation } from '@tanstack/react-query';
import useGetMarketingData from './useGetMarketingData';
import { createSegment, invalidateSegments } from '../../services/marketing';
import {
  FinalCampaignSegment,
  finalCampaignSegmentSchema,
  MarketingCampaignSegmentWithFilters,
} from '../../types/marketing';

interface Options {
  onSuccess?: (
    result: MarketingCampaignSegmentWithFilters,
  ) => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useCreateSegment({ onSuccess, onError }: Options = {}) {
  const { data: marketingData, isFetching: isFetchingMarketing } =
    useGetMarketingData();

  return useMutation({
    mutationFn: async (segment: FinalCampaignSegment) => {
      if (!marketingData?.id || isFetchingMarketing) return null;

      const validatedBody = await finalCampaignSegmentSchema
        .noUnknown()
        .validate(segment, {
          stripUnknown: true,
        });

      const result = await createSegment(marketingData.id, validatedBody);
      return result;
    },
    onSuccess: async result => {
      if (!result) return;
      await invalidateSegments();
      await onSuccess?.(result);
    },
    onError,
  });
}

export default useCreateSegment;
